/* src/app/modules/cooling-companion/components/cooling-system-details/cooling-system-details.component.scss */
app-system-status {
  display: block;
  margin-bottom: 10px;
}
.graph-datepicker {
  width: 17rem;
}
.cooling-system-details-container {
  box-shadow: var(--shadow-raised);
  background-color: white;
  padding: 2rem;
}
.coolingDataHeader {
  margin-bottom: 0%;
}
.dateHeader {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding-bottom: 1rem;
}
.timezoneOffset {
  white-space: nowrap;
  width: max-content;
}
.custom-graph-cards {
  margin-top: 1%;
  margin-bottom: 1%;
}
.date-picker-base {
  display: flex;
}
.custom-graph-card-inputs-before-submit {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 8px;
  margin: 12px 0;
}
.custom-graph-card-inputs-before-submit .mat-parameter-form-field,
.custom-graph-card-inputs-before-submit .date-picker-custom {
  flex: 1 1 0;
  max-width: 50%;
}
.custom-graph-card-actions-before-submit {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.custom-graph-card-inputs .date-picker-custom {
  display: flex;
}
.add-date-range-button-wrapper {
  display: flex;
  justify-content: flex-end;
}
.add-date-range-button {
  padding: 0 16px;
  white-space: nowrap;
  height: 40px;
}
.custom-graph-card-header-with-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
/*# sourceMappingURL=cooling-system-details.component.css.map */
